import createMailFolderTableQuery from './createMailFolderTableQuery';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { updateWatermarkAndResetRollup } from 'owa-mail-focused-inbox-rollup-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import { action, orchestrator } from 'satcheljs';
// Select focused view filter
var selectFocusedViewFilter = action('selectFocusedViewFilter', function (focusedViewFilter, actionSource) { return ({
    focusedViewFilter: focusedViewFilter,
    actionSource: actionSource,
    datapointConfig: {
        name: 'TnS_SelectPivot',
        options: { isCore: true },
        customData: [focusedViewFilter, actionSource],
    },
}); });
orchestrator(selectFocusedViewFilter, function (_a) {
    var focusedViewFilter = _a.focusedViewFilter;
    var selectedTableView = getSelectedTableView();
    // Update last visit watermark for selected pivot and reset rollup data
    updateWatermarkAndResetRollup(focusedViewFilter, 'NonUserAction');
    // Always reset the view filter when user switches the focused pivot
    var tableQuery = createMailFolderTableQuery(selectedTableView.tableQuery.folderId, selectedTableView.tableQuery.listViewType, 'mail', focusedViewFilter);
    return loadTableViewFromTableQuery(tableQuery);
});
export default selectFocusedViewFilter;
//# sourceMappingURL=selectFocusedViewFilter.js.map